export const updateQueryVariable = (variable: string, value: string): void => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(variable, value);

    const newRelativePathQuery = `${window.location.pathname}?${searchParams.toString()}`;
    history.replaceState(null, "", newRelativePathQuery);
};
